//Imports 
import './index.css';
import Home from './pages/Home';
import Cart from './pages/Cart';
import Payment from './pages/Payment';
import MyOrders from './pages/MyOrders';
import Navbar from './components/Navbar';
import Confirmation from './pages/Confirmation';
import ProductDetails from './pages/ProductDetails';
import { CartProvider } from './context/CartContext';
import { OrderProvider } from './context/OrderContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProductProvider } from './context/ProductContext';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

//Main App Component
function App() {
  return (
    <ProductProvider>
      <CartProvider>
        <OrderProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="app-container">
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/confirmation" element={<Confirmation />} />
                  <Route path="/payment" element={<Payment />} />
                  <Route path="/orders" element={<MyOrders />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </OrderProvider>
      </CartProvider>
    </ProductProvider>
  );
}

export default App;
